import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

import { LocalisePipe } from '../../../../modules/pipes/localise.pipe';
import { AgreementTextComponent } from '../../../../modules/shared/components/agreement-text/agreement-text.component';
import { ProductEnum } from '../../../authentication/models/product.enum';
import { AuthenticationService } from '../../../authentication/services/authentication.service';
import { AgreementTypeEnum } from '../../../shared/models/agreement-type.enum';
import { IUserAgreement } from '../../../shared/models/user-agreement.interface';
import { AgreementService } from '../../../shared/services/agreement.service';
import { SharedService } from '../../../shared/services/shared.service';
import { InviteSignupProcessService } from '../../services/invite-signup-process.service';

@Component({
  selector: 'app-invite-signup-process-contract',
  templateUrl: './invite-signup-process-contract.component.html',
  styleUrls: ['./invite-signup-process-contract.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatCheckboxModule,
    MatButtonModule,
    AgreementTextComponent,
    LocalisePipe,
  ],
})
export class InviteSignupProcessContractComponent implements OnInit {
  public agreement: IUserAgreement;
  public loading = false;
  public error = '';
  public form = this.formBuilder.group({
    privacyPolicy: [false, [Validators.requiredTrue]],
    consentBusiness: [false, [Validators.requiredTrue]],
    stripeCeltic: [false, [Validators.requiredTrue]],
    astraTerms: [false, [Validators.requiredTrue]],
  });

  constructor(
    public inviteSignupProcessService: InviteSignupProcessService,
    private agreementService: AgreementService,
    private sharedService: SharedService,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    const user = this.authenticationService.getProfileState();
    if (
      !user.productIds.includes(ProductEnum.Payment) ||
      user.agreementSignatures.length !== 0
    ) {
      this.inviteSignupProcessService.nextStep();
      return;
    }
    this.load();
  }

  public async next(): Promise<void> {
    if (this.form.invalid) {
      return;
    }

    this.loading = true;

    try {
      await this.agreementService
        .signAgreement(
          this.agreement.id,
          AgreementTypeEnum.UserAgreementInvitationFromBroker,
          {
            userAgent: navigator.userAgent,
          },
        )
        .toPromise();
      const user = this.authenticationService.getProfileState();
      if (user.productIds.includes(ProductEnum.Advance)) {
        this.inviteSignupProcessService.nextStep();
      } else {
        this.inviteSignupProcessService.close.next();
      }
    } catch (e) {
      this.error = this.sharedService.getErrorText(e, true);
    }

    this.loading = false;
  }

  async load(): Promise<void> {
    this.agreement = await firstValueFrom(
      this.agreementService.getAgreement(
        AgreementTypeEnum.UserAgreementInvitationFromBroker,
      ),
    );
  }
}
